import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./WelocateFilterButton.css";

const MOBILE_QUERY = "(max-width: 768px)";

const WelocateFilterButton = ({ label, sublabel, children, active, open, onOpenChange }) => {
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
  const [tailX, setTailX] = useState(null);
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(MOBILE_QUERY);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    if (!open) return;
    const handleOutsideClick = (e) => {
      const inWrapper = wrapperRef.current && wrapperRef.current.contains(e.target);
      const inDropdown = dropdownRef.current && dropdownRef.current.contains(e.target);
      if (!inWrapper && !inDropdown) {
        onOpenChange(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [open, onOpenChange]);

  useEffect(() => {
    if (!open) {
      setTailX(null);
      return;
    }
    const update = () => {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        setTailX(null);
        return;
      }
      if (!wrapperRef.current) return;
      const rect = wrapperRef.current.getBoundingClientRect();
      setTailX(rect.left + rect.width / 2);
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [open]);

  return (
    <div className="wl-filter-btn-wrapper" ref={wrapperRef}>
      <button
        className={`wl-filter-btn${open ? " wl-filter-btn--open" : ""}${active ? " wl-filter-btn--active" : ""}`}
        onClick={() => onOpenChange(!open)}
      >
        <span className="wl-filter-btn-label">
          {label}
          {sublabel != null && (
            <span className="wl-filter-btn-sublabel"> · {sublabel}</span>
          )}
        </span>
        <svg
          className={`wl-filter-btn-chevron${open ? " wl-filter-btn-chevron--up" : ""}`}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 4L6 8L10 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {open && isMobile && createPortal(
        <>
          <div
            className="wl-filter-backdrop"
            onMouseDown={() => onOpenChange(false)}
            aria-hidden="true"
          />
          {tailX != null && (
            <div
              className="wl-filter-dropdown-tail"
              style={{ "--wl-tail-x": `${tailX}px` }}
            />
          )}
          <div className="wl-filter-dropdown" ref={dropdownRef}>
            {children}
          </div>
        </>,
        document.body
      )}
      {open && !isMobile && (
        <div className="wl-filter-dropdown" ref={dropdownRef}>
          {children}
        </div>
      )}
    </div>
  );
};

export default WelocateFilterButton;
